var isServer = typeof window === "undefined";

export { isServer as default };
//# sourceMappingURL=isServer.mjs.map
